import { debounce } from 'lodash';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAccessControlEmployer,
  updateProps,
} from '../../../contextRedux/AccessControlEmployer/AccessControlEmployerModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { AccessControlEmployerColumn } from './AccessControlEmployerColumn';

const AccessControlEmployerTable: FC<any> = () => {
  const dispatch = useDispatch();

  const reduxAccessControlEmployer = useSelector((state: RootState) => state.models?.accessControlEmployer);
  const accessControlEmployers = useSelector((state: RootState) => state.store?.accessControlEmployer.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxAccessControlEmployer.props.skip / reduxAccessControlEmployer.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = (record: any) => {
    dispatch(setAccessControlEmployer(record));
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxAccessControlEmployer.props.take,
    total: reduxAccessControlEmployer.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxAccessControlEmployer.props.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={accessControlEmployers}
        pagination={paginationConfig}
        columns={AccessControlEmployerColumn(handleEdit)}
        rowKey='id'
        className='table'
      />
    </>
  );
};

export default AccessControlEmployerTable;
